import { ApplicationConfig, provideBrowserGlobalErrorListeners, provideZoneChangeDetection } from '@angular/core';
import { appRoutes } from './app.routes';
import { provideUiMaterial } from '@frontend-mono/shared-themes';
import { protectedUrls, provideAuth, provideAuthHttp, provideAuthRouter } from '@frontend-mono/shared-auth';
import { provideAppConfig } from '@frontend-mono/config';
import { provideI18n } from '@frontend-mono/shared-i18n';
export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: protectedUrls,
      useValue: [APP_CONFIG.API_URL],
    },
    provideAuth(),
    provideAuthHttp(),
    provideAppConfig(),
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideAuthRouter(appRoutes),
    provideI18n(['en', 'de'], 'en'),
    provideUiMaterial(),
  ]
};
